<nk-card>
  <nk-card-header>
    <div class="d-flex">
      <h6 class="card-heading"><i class="fa fa-sticky-note-o me-2"></i>{{ 'collateral_card.title' | translate }}</h6>
      <div class="btn-group float-end text-end ms-auto">
        <div class="form-check form-check-inline">
          <nk-checkbox [(ngModel)]="showForCorporateGroup">
            {{ 'collateral_card.show_corporate_group' | translate }}
          </nk-checkbox>
        </div>
        <div class="form-check form-check-inline">
          <nk-checkbox [(ngModel)]="includeDeletedCollateral">
            {{ 'collateral_card.include_deleted_collateral' | translate }}
          </nk-checkbox>
        </div>
      </div>
    </div>
  </nk-card-header>
  <nk-company-collateral-chart
    id="collateral-chart"
    [companyUuid]="companyUuid()"
    [showForCorporateGroup]="showForCorporateGroup"></nk-company-collateral-chart>
  <nk-card-content type="table">
    <nk-company-collateral-table
      id="collateral-table"
      [companyUuid]="companyUuid()"
      [showForCorporateGroup]="showForCorporateGroup"
      [includeDeletedCollateral]="includeDeletedCollateral"></nk-company-collateral-table>
  </nk-card-content>
</nk-card>
